import { render, staticRenderFns } from "./TrainingSubmissionModule.vue?vue&type=template&id=04b5e7d7&scoped=true&"
import script from "./TrainingSubmissionModule.vue?vue&type=script&lang=js&"
export * from "./TrainingSubmissionModule.vue?vue&type=script&lang=js&"
import style0 from "./TrainingSubmissionModule.vue?vue&type=style&index=0&id=04b5e7d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b5e7d7",
  null
  
)

export default component.exports